/**
 * ATENÇÃO, ESTE ARQUIVO NÃO DEVE SER ALTERADO. SE NECESSÁRIO CRIE AS VARIÁVEIS DE AMBIENTE NA SUA MÁQUINA
 */

export const host = process.env.REACT_APP_BASE_URL ?? 'http://localhost:3070'